import { defineMessages } from 'react-intl';

import removeFromCollectionHover from '../../static/icons/actions/ic_remove_circle_filled_24.svg';
import removeFromCollection from '../../static/icons/backstage/ic_check_circle_filled_24.svg';
import more from '../../static/icons/backstage/ic_more_circle_24.svg';
import play from '../../static/icons/backstage/ic_play_circle_48.svg';
import addToCollection from '../../static/icons/ic_add_circle_24.svg';
import share from '../../static/icons/ic_share_circle_24.svg';
import shuffle from '../../static/icons/ic_shuffle_circle_24.svg';

export const ButtonRowButtonSize = Object.freeze({
  play: 'large',
  pause: 'large',
  playStation: 'large',
});

export const ButtonRowType = Object.freeze({
  ADD_TO_COLLECTION: 'addToCollection',
  DELETE_PLAYLIST: 'deletePlaylist',
  REMOVE_FROM_COLLECTION: 'removeFromCollection',
  DELETE_STATION: 'deleteStation',
  SHUFFLE: 'shuffle',
  CREATE_STATION: 'createStation',
  PLAY: 'play',
  PAUSE: 'pause',
  SHARE: 'share',
  MORE: 'more',
  EDIT: 'edit',
});

export const ButtonTextType = Object.freeze({
  PLAY_STATION: 'playStation',
  PLAY_ALBUM: 'playAlbum',
  PLAY_PLAYLIST: 'playPlaylist',
  PLAY_TOP_SONGS: 'playTopSongs',
  PLAY_SONG: 'playSong',
  PAUSE_SONG: 'pauseSong',
  PAUSE_ALBUM: 'pauseAlbum',
  PLAY_PODCAST: 'playPodcast',
  PAUSE_PODCAST: 'pausePodcast',
  PLAY_EPISODE: 'playEpisode',
  PAUSE_EPISODE: 'pauseEpisode',
  PLAY: 'play',
  PAUSE: 'pause',
});

export const ButtonRowIcons = Object.freeze({
  addToCollection: { default: addToCollection },
  removeFromCollection: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  deleteStation: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  deletePlaylist: {
    default: removeFromCollection,
    hover: removeFromCollectionHover,
  },
  shuffle: { default: shuffle },
  play: { default: play },
  share: { default: share },
  more: { default: more },
});

export const ButtonRowText = defineMessages({
  addToCollection: {
    id: 't.addToCollection',
    defaultMessage: 'Collect',
  },
  deletePlaylist: {
    id: 't.deletePlaylist',
    defaultMessage: 'Delete Playlist',
  },
  removeFromCollection: {
    id: 't.removeFromCollection',
    defaultMessage: 'Remove from your collection',
  },
  shuffle: {
    id: 't.shuffle',
    defaultMessage: 'Shuffle',
  },
  share: {
    id: 't.share',
    defaultMessage: 'Share',
  },
  more: {
    id: 't.more',
    defaultMessage: 'More',
  },
  play: {
    id: 't.play',
    defaultMessage: 'Play',
  },
  pause: {
    id: 't.pause',
    defaultMessage: 'Pause',
  },
  playAlbum: {
    id: 't.playAlbum',
    defaultMessage: 'Play Album',
  },
  playStation: {
    id: 't.playStation',
    defaultMessage: 'Start Station',
  },
  playPlaylist: {
    id: 't.playPlaylist',
    defaultMessage: 'Play Playlist',
  },
  playTopSongs: {
    id: 't.playTopSongs',
    defaultMessage: 'Play Top Songs',
  },
  playSong: {
    id: 't.playSong',
    defaultMessage: 'Play Song',
  },
  pauseSong: {
    id: 't.pauseSong',
    defaultMessage: 'Pause Song',
  },
  pauseAlbum: {
    id: 't.pauseAlbum',
    defaultMessage: 'Pause Album',
  },
  playPodcast: {
    id: 't.playPodcast',
    defaultMessage: 'Play Podcast',
  },
  pausePodcast: {
    id: 't.pausePodcast',
    defaultMessage: 'Pause Podcast',
  },
  playEpisode: {
    id: 't.playEpisode',
    defaultMessage: 'Play Episode',
  },
  pauseEpisode: {
    id: 't.pauseEpisode',
    defaultMessage: 'Pause Episode',
  },
  edit: {
    id: 't.edit',
    defaultMessage: 'Edit',
  },
  deleteStation: {
    id: 't.deleteStation',
    defaultMessage: 'Delete Station',
  },
});
